// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"eac8756a","271":"ddcc9c56"}[chunkId] + ".chunk.js";
};